import React, { useEffect, useRef } from "react"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, Modal, Spinner } from "components"
import classes from "./PcPosTerminalPaymentStatusModal.module.scss"

const PcPosTerminalPaymentStatusModal = props => {
  const {
    pcPosTerminalPaymentStatus,
    openPcPosTerminalPaymentStatusModal,
    setOpenPcPosTerminalPaymentStatusModal
  } = props

  const [t, i18n] = useTranslation()

  const timeout = useRef()

  const handleCancel = () => {
    setOpenPcPosTerminalPaymentStatusModal(false)
  }

  const closeModalAfterThreeSeconds = () => {
    if (pcPosTerminalPaymentStatus === "loading") return

    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(() => setOpenPcPosTerminalPaymentStatusModal(false), 3000)
  }

  useEffect(() => {
    closeModalAfterThreeSeconds()
  }, [pcPosTerminalPaymentStatus])

  useEffect(() => {
    return () => { clearTimeout(timeout.current) }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openPcPosTerminalPaymentStatusModal}
      onEnter={() => setOpenPcPosTerminalPaymentStatusModal("sendingRequest")}
      backdrop="static"
    >
      <div className={classes["container"]}>
        {
          pcPosTerminalPaymentStatus === "loading" &&
          <div className={classes["row"]}>
            <span className={classes["text"]}>
              {t("در_حال_پرداخت")}
            </span>

            <Spinner
              className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
              color="var(--color-primary)"
            />
          </div>
        }

        {
          pcPosTerminalPaymentStatus === "success" &&
          <div className={classes["row"]}>
            <span className={classes["text"]}>
              {t("پرداخت_انجام_شد")}
            </span>

            <FaCheckCircle
              size={20}
              color="var(--color-success)"
              className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
            />
          </div>
        }

        {
          pcPosTerminalPaymentStatus === "failed" &&
          <div className={classes["row"]}>
            <span className={classes["text"]}>
              {t("پرداخت_انجام_نشد")}
            </span>

            <FaTimesCircle
              size={20}
              color="var(--color-danger)"
              className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
            />
          </div>
        }

        {
          pcPosTerminalPaymentStatus === "loading" &&
          <div className={classes["footer"]}>
            <Button
              onClick={handleCancel}
              color="danger"
            >
              {t("لغو_پرداخت")}
            </Button>
          </div>
        }
      </div>
    </Modal>
  )
}

export default PcPosTerminalPaymentStatusModal